import CommonLayout from "components/CommonLayout";
import ShowToast from "components/MDToast";
import useTranslation from "hooks/Translation";
import React, { useEffect, useState } from "react";
import { useLazyGetAdminCmsQuery } from "services/settings";
import { useLazyGetCmsQuery } from "services/settings";

const About = () => {
  const [getAgreement] = useLazyGetAdminCmsQuery();
  const [agreementData, setAgreementData] = useState("");
  const t = useTranslation();

  const getAllSupport = async (page) => {
    try {
      const response = await getAgreement({}).unwrap();
      if (response?.status === 200) {
        setAgreementData(response?.data?.about_us);
      }
    } catch (error) {
      ShowToast(error?.data?.message || "", "error");
    }
  };

  useEffect(() => {
    getAllSupport();
  }, []);

  return (
    <CommonLayout>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{}}>
          <h1
            style={{ textAlign: "center", paddingTop: 10, paddingBottom: 10 }}
          >
            {t.main.aboutUs}
          </h1>
          <div
            style={{ textAlign: "center", fontSize: "22px" }}
            dangerouslySetInnerHTML={{
              __html: agreementData ? agreementData : "No Data Found",
            }}
          ></div>
        </div>
      </div>
    </CommonLayout>
  );
};

export default About;
